import React, { useState } from "react";
import StudentsSearchSec from "./StudentsSearchSec";
import StudentsTable from "./StudentsTable";
import { manageStudents } from "../../../../api/org-admin";
import { Pagination } from "antd";

const AllStudentsMain = ({
  studentsData,
  pageCount,
  currentPage,
  onPageChange,
  pageSize,
  setCreateBatchFlag,
  sortItems,
  setSearchValue,
  searchValue,
  searchText,
  setSearchText,
  setSortBy,
  sortBy,
  refreshApis,
  setSelectedUserIds,
  selectedUserIds,
}) => {
  return (
    <div className="mt-4">
      <StudentsSearchSec
        studentsData={studentsData}
        setCreateBatchFlag={setCreateBatchFlag}
        refreshApis={refreshApis}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        searchText={searchText}
        setSearchText={setSearchText}
        setSortBy={setSortBy}
        sortBy={sortBy}
        sortItems={sortItems}
        setSelectedUserIds={setSelectedUserIds}
        selectedUserIds={selectedUserIds}
      />
      <StudentsTable
        studentsData={studentsData}
        setSelectedUserIds={setSelectedUserIds}
        selectedUserIds={selectedUserIds}
        noCheckboxRequired={true}
      />
      <div className="flex justify-center mt-3 mb-1">
        <Pagination
          current={currentPage + 1}
          total={pageCount}
          pageSize={pageSize}
          onChange={onPageChange}
          showSizeChanger={true} // ✅ enable page size selector
          pageSizeOptions={["5", "10", "15", "20"]} // options for items per page
        />
      </div>
    </div>
  );
};

export default AllStudentsMain;
